module.exports = __webpack_public_path__ + "img/image-user-plus.07b1efa2.svg";